import {
  Component,
  OnInit,
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {TranslateService} from "ng2-translate";
import {DEFAULT_VIDEO_CALL_URL} from "../services/constants";
import {WedomeetService} from "../services/wedomeet/wedomeet.service";
import {VideoCallService} from "../services/video-call/video-call.service";
import {MeetingVM} from "../models/MeetingVM.model";
import {MeetingUserVM} from "../models/MeetingUserVM.model";
import {ServantService} from "../services/servant-service/servant-service";
import {ServantVM} from "../models/ServiceItemDetailVM";
import {PaymentResultVM} from "../models/PaymentResultVM.model";
import {AlertService} from "../services/alert/alert.service";
import {DateUtilService} from "../services/date-service/DateUtilService";
import {CompanyService} from "../services/company-service/company-service";
import {CompanyVM} from "../models/CompanyVM.model";
import {VideoCallSettingInfoVM} from "../models/VideoCallSettingInfoVM.model";

@Component({
  selector: 'wedomeet-video',
  template: require('./wedomeet-video.component.html'),
  providers: [WedomeetService,OrderBagService,ServantService,VideoCallService],
  styles: [require('./wedomeet-video.component.css')]

})
export class WedomeetVideoComponent implements OnInit {


  public order_detail;
  public displayMessage = '';
  public status;
  public id;
  public userShouldPay = false;
  public totalPrice;
  public isLoaded = false;
  public authorityCode;
  public refid;
  public clientrefid
  public statusstr = '-';
  public externalURL_fromWidget;
  public pageTitle:string= '';
  public meetingId;
  public password:string;
  public fullName:string;
  public order_detail_id;
  public servant;
  public newMeeting;
  public isModerator =false ;
  company: CompanyVM;
  videoCallSetting;
  public showPassword : boolean = false;
  public showWedomeetBranding : boolean = false;
  public platformType = null ;


  constructor(private activatedRoute: ActivatedRoute,
              private wedomeetService: WedomeetService,
              private orderBagService: OrderBagService,
              private servantService: ServantService,
              private translate: TranslateService,
              private alertService:AlertService,
              private companyService: CompanyService,
              private videoCallService: VideoCallService,
  ) {

    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      // console.log(params['reserveId']);
      this.getOrderBagDetail(+params['reserveId']);

      if(params['participantType'] == 'm')
      {
        this.isModerator = true;
      }

    });


    this.companyService.getCompanyInfo().subscribe((c: CompanyVM) => {
      this.company = c;
    });



  }

  public getOrderBagDetail(id) {
    let parent = this;
    parent.orderBagService.getOrderBagDetailById(id).subscribe(detail => {
      parent.order_detail = detail;
      parent.order_detail_id = parent.order_detail.items[0].orderBagItemId;
      if(parent.order_detail.servantId)
        this.getServantById(parent.order_detail.servantId);

      //remove past event when items.length > 1
      if(parent.order_detail.items.length > 1)
      {
        parent.order_detail.items = parent.order_detail.items.filter((item)=> {
          let now = new Date();
          let endTime = new Date(item.timesession.endTime);
          if(endTime >= now)
            return item;
        });
      }


      parent.order_detail.items.sort((val1, val2)=> {
        return <any>new Date(val1.timesession.startDate) - <any>new Date(val2.timesession.startDate);
      })
      if (detail.status == 0)
        this.isLoaded = false;

      this.createVideoMeetingId(this.order_detail_id);

      this.videoCallService.getVideoCallSettingByOrderBagItemId(this.order_detail_id).subscribe( (videoSetting:VideoCallSettingInfoVM)=> {
        this.videoCallSetting = videoSetting;
      });

      this.setPageTitle();
    })
  }

  public getServantById(servantId)
  {

    this.servantService.getServantById(servantId).subscribe(result => {
      this.servant = result;
    })

  }


  public setPageTitle() {
    let title = "رزرو" + " : " + this.order_detail.id + " - " + this.order_detail.serviceTitle;
    this.pageTitle = title;
  }

  public isMeetingRunning(item){
    let result ;
    this.wedomeetService.isMeetingRunning(item.orderBagItemId).subscribe(data => {

      result = data;
      return result;
    })
  }

  public createVideoMeetingId(orderBagItemId)
  {
    this.meetingId = '';
    if(orderBagItemId)
    {
      // call service
      this.orderBagService.getVideoMeetingLinkByOrderBagItemId(orderBagItemId).subscribe(result => {
        if(result)
        {
          // go to url
          let link = result.link;
          this.meetingId = link;
        }

      })
    }
  }

  public createMeeting(item)
  {
    let newMeeting :MeetingVM  ;
    // newMeeting.maxParticipant=item.serviceItem.capacityInfo.
    // newMeeting.duration
    newMeeting = new MeetingVM();
    newMeeting.meetingId = this.meetingId;
    // newMeeting.meetingName = this.order_detail.serviceTitle;
    newMeeting.meetingName = "Service";
    newMeeting.moderatorPW = this.order_detail.servantId;
    newMeeting.attendeePW = '123456';
    newMeeting.orderBagItemId = item.orderBagItemId;
    newMeeting.password = this.password;
    this.wedomeetService.createMeeting(newMeeting).then(detail => {
        if(detail.status =='DONE')
        {

          this.joinModerator(detail);
        }
        else if(detail.status== 'SESSION_NOT_START_YET')
        {
          this.alertService.showErrorMessage("meeting.messages.SESSION_NOT_START_YET");
          return;
        }
        else if(detail.status== 'PASSWORD_IS_WRONG')
        {
          this.alertService.showErrorMessage("meeting.messages.PASSWORD_IS_WRONG");
          return;
        }
        else if(detail.status== 'PASSWORD_NOT_ENTERED')
        {
          this.alertService.showErrorMessage("meeting.messages.PASSWORD_NOT_ENTERED");
          return;
        }
        else
        {
          this.alertService.showErrorMessage("meeting.messages.FAILED");
          return;
        }
    }).catch((er) => {

      this.alertService.showErrorMessage("meeting.messages.FAILED");
        //
    });;


  }
  public joinModerator(meetingResponse) {

    // let url = this.wedomeetService.joinmoMeeting(user);

    if (!meetingResponse.joinMeetingURL) {

      this.alertService.showErrorMessage("meeting.messages.join_meeting_url_not_presented")
      return;
    }



    let url = meetingResponse.joinMeetingURL;
    window.open(url,'_self');
  }



  public startVideoCall(item)
  {
    item.showError = false;
    this.videoCallService.getVideoCallSettingByOrderBagItemId(item.orderBagItemId).subscribe( (videoSetting:VideoCallSettingInfoVM)=> {
      this.videoCallSetting = videoSetting;
      if(this.videoCallSetting)
      {
        if(this.videoCallSetting.platformType)
        {
          if(this.videoCallSetting.platformType === 'JITSI_MEET' ||
            this.videoCallSetting.platformType === 'GOOGLE_MEET' ||
            this.videoCallSetting.platformType === 'SKYPE' ||
            this.videoCallSetting.platformType === 'CUSTOM'
          )
            this.showPassword = false;
          if(this.videoCallSetting.platformType === 'WEDOMEET' )
            this.showWedomeetBranding = true;
          if(this.videoCallSetting.platformType === 'NONE' )
            item.showError = true;




          this.platformType = this.videoCallSetting.platformType;

          switch (this.videoCallSetting.platformType) {
            case 'WEDOMEET':
              this.startVideoCallWedomeet(item);
              break;
            case 'JITSI_MEET':
              this.startVideoCallJitsi(item);
              break;
            case 'GOOGLE_MEET':
              this.startVideoCallGoogleMeet(item);
              break;
            case 'SKYPE':
              this.startVideoCallSkype(item);
              break;
            case 'CUSTOM':
              this.startVideoCallCustom(item);
              break;}

        }
        else
          item.showError = true;

      }
      else
        item.showError = true;

    })

  }

  public startVideoCallWedomeet(item)
  {

    if(!this.password)
      return;

    this.wedomeetService.isMeetingRunning(item.orderBagItemId).subscribe(data => {

      if(data)
      {
        this.joinMeeting(item);
      }
      else{
        this.createMeeting(item);
      }
    })

  }

  public startVideoCallJitsi(item)
  {
    // if(!this.password)
    //   return;

    this.videoCallService.getMeetingUrl(item.orderBagItemId).subscribe(data => {
      if(data && data.joinMeetingURL)
        this.goToMeetingUrl(data.joinMeetingURL);
    })

  }
  public startVideoCallGoogleMeet(item)
  {
    // if(!this.password)
    //   return;

    this.videoCallService.getMeetingUrl(item.orderBagItemId).subscribe(data => {
      if(data && data.joinMeetingURL)
        this.goToMeetingUrl(data.joinMeetingURL);
    })

  }

  public startVideoCallSkype(item)
  {
    // if(!this.password)
    //   return;
    this.videoCallService.getMeetingUrl(item.orderBagItemId).subscribe(data => {
      if(data && data.joinMeetingURL)
        this.goToMeetingUrl(data.joinMeetingURL);
    })

  }

  public startVideoCallCustom(item)
  {
    // if(!this.password)
    //   return;
    this.videoCallService.getMeetingUrl(item.orderBagItemId).subscribe(data => {
      if(data && data.joinMeetingURL)
        this.goToMeetingUrl(data.joinMeetingURL);
    })

  }


  public goToMeetingUrl(url){
    window.open(url,'_self');
  }

  public joinMeeting(item)
  {

    let newMeeting :MeetingVM  ;
    // newMeeting.maxParticipant=item.serviceItem.capacityInfo.
    // newMeeting.duration
    newMeeting = new MeetingVM();
    // newMeeting.meetingId = this.meetingId;
    newMeeting.orderBagItemId = item.orderBagItemId;
    newMeeting.password = this.password;
    newMeeting.fullName = this.fullName;

    this.wedomeetService.joinMeeting(newMeeting).then(detail => {
      if(detail.status =='DONE')
      {
        if(detail.joinMeetingURL)
        {
          let url = detail.joinMeetingURL;
          // window.open(url);
          window.open(url,'_self');
        }

        else{
          this.alertService.showErrorMessage("meeting.messages.join_meeting_url_not_presented")
          return;
        }
      }
      else
      {

        this.alertService.showErrorMessage("meeting.messages."+detail.status);
        return;
      }
    }).catch((er) => {

      this.alertService.showErrorMessage("meeting.messages.FAILED")
      return;
      //
    });
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/wedomeet-video/wedomeet-video.component.ts